import Resource from './common/resource';

class EmailAddresses extends Resource {
  path = 'senders';
}

export default EmailAddresses;
